import { ListItemIcon, RedListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Remove from '@/images/Remove.svg';
import { Presenter } from '@d-id/types';
import { useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    avatar: Presenter;
    onDelete: (avatar: Presenter) => void;
    closeMenu: () => void;
}

export const DeleteMenuItem = ({ avatar, onDelete, closeMenu }: Props) => {
    const theme = useTheme();

    return (
        <MenuItem
            onClick={() => {
                onDelete(avatar);
                closeMenu();
            }}>
            <ListItemIcon>
                <MaskedIcon src={Remove} size="24px" color={theme.colors.error.main} />
            </ListItemIcon>
            <RedListItemText>Delete Avatar</RedListItemText>
        </MenuItem>
    );
};
